import { isEmpty } from "lodash";
import qs from "qs";

import { axiosWithAuth } from "helpers";
import { getSubStatuses } from "models/applicationEntry/status";

export const applicationListService = {
	assignToUser,
	cloneMpa,
	copyMpaDocument,
	getAllApplications,
	getApplicationDocuments,
	getApplicationsCounters,
	getAssignedUsers,
	getDrafts,
	getPended,
	getPreApplications,
	getSignedMPAs,
	getStatusList,
	removeApplication,
	saveApplicationDocumentsCopy,
};

const API_URL = process.env.REACT_APP_API_URL;
const PAGE_SIZE = 50;

function getStatusList() {
	const options = {
		method: "GET",
		url: `${API_URL}/api/dropdown/application/statuses`,
	};

	return axiosWithAuth(options);
}

function getApplicationsCounters() {
	const options = {
		method: "GET",
		url: `${API_URL}/api/applications/counters`,
	};

	return axiosWithAuth(options);
}

const mapAppListParams = (filters = {}, page, sortBy) => {
	let params = {};

	if (isEmpty(filters.applicationStatus?.subStatuses)) {
		params = {
			sub_status_ids: filters.applicationStatus?.id,
		};
	} else {
		params = {
			sub_status_ids: getSubStatuses(
				filters.applicationStatus?.subStatuses,
			),
		};
	}

	params = {
		...params,
		number: filters.number,
		mid: filters.mid,
		merchant_name: filters.merchantName,
		merchant_status_id: filters.merchantStatus?.id,
		processor_id: filters.processor?.id,
		sponsor_id: filters.sponsor?.id,
		agent_office: filters.agentOffice,
		agent_name: filters.agentName,
		pend_status: filters.pendStatus?.name,
		pended_to_id: filters.pendedTo?.id,
		draft_assignee_id: filters.assignedTo?.id,
		page_index: page,
		page_size: PAGE_SIZE,
		sort_type: sortBy?.id || undefined,
		ascending: sortBy?.id ? sortBy?.desc : undefined,
	};

	return params;
};

function getAllApplications({ page, filters, sortBy }) {
	return axiosWithAuth({
		method: "GET",
		traditional: true,
		url: `${API_URL}/api/applications`,
		params: mapAppListParams(filters, page, sortBy),
		paramsSerializer: params =>
			qs.stringify(params, { arrayFormat: "repeat" }),
	});
}

function getSignedMPAs({ page, filters, sortBy }) {
	return axiosWithAuth({
		method: "GET",
		url: `${API_URL}/api/applications/signed_mpas`,
		params: mapAppListParams(filters, page, sortBy),
		paramsSerializer: params =>
			qs.stringify(params, { arrayFormat: "repeat" }),
	});
}
function getPreApplications({ page, filters, sortBy }) {
	return axiosWithAuth({
		method: "GET",
		url: `${API_URL}/api/applications/pre_applications`,
		params: mapAppListParams(filters, page, sortBy),
		paramsSerializer: params =>
			qs.stringify(params, { arrayFormat: "repeat" }),
	});
}
function getPended({ page, filters, sortBy }) {
	return axiosWithAuth({
		method: "GET",
		url: `${API_URL}/api/applications/pended`,
		params: mapAppListParams(filters, page, sortBy),
		paramsSerializer: params =>
			qs.stringify(params, { arrayFormat: "repeat" }),
	});
}

function getDrafts({ page, filters, sortBy }) {
	return axiosWithAuth({
		method: "GET",
		url: `${API_URL}/api/applications/list/drafts`,
		params: mapAppListParams(filters, page, sortBy),
		paramsSerializer: params =>
			qs.stringify(params, { arrayFormat: "repeat" }),
	});
}

function getApplicationDocuments(id) {
	const options = {
		method: "GET",
		url: `${API_URL}/api/applications/list/${id}/documents`,
	};

	return axiosWithAuth(options);
}

function saveApplicationDocumentsCopy(id, copyDocuments) {
	const options = {
		method: "POST",
		url: `${API_URL}/api/applications/list/${id}/copy`,
		data: copyDocuments,
	};

	return axiosWithAuth(options);
}

function cloneMpa(appId) {
	const options = {
		method: "POST",
		url: `${API_URL}/api/signed_mpa/${appId}/clone`,
	};
	return axiosWithAuth(options);
}

function copyMpaDocument(appId, documentId) {
	const options = {
		method: "POST",
		url: `${API_URL}/api/signed_mpa/${appId}/copy_document/${documentId} `,
	};
	return axiosWithAuth(options);
}

function getAssignedUsers(pattern, page, showInactive = false) {
	const body = {
		pattern,
		page,
		pageSize: 20,
		showInactive,
	};

	const options = {
		method: "POST",
		data: body,
		url: `${API_URL}/api/dropdown/Users`,
	};

	return axiosWithAuth(options);
}

function assignToUser({ applicationId, assigneeId }) {
	const options = {
		method: "GET",
		url: `${API_URL}/api/applications/${applicationId}/assigneeTo/${assigneeId}`,
	};

	return axiosWithAuth(options);
}

function removeApplication(applicationId) {
	const options = {
		method: "DELETE",
		url: `${API_URL}/api/applications/${applicationId}`,
	};

	return axiosWithAuth(options);
}
